import {
  themeParse,
  themeStringParse,
} from '@mercadoni/sinister/dist/cjs/themes'
import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import { css } from 'styled-components'
import isSSR from './isSSR'

// fallback primary colors
const stylesComputed = isSSR()
  ? { getPropertyValue: () => null }
  : getComputedStyle(document.documentElement)

const PRIMARY = stylesComputed.getPropertyValue('--color-primary') || '#ccc'
const PRIMARY2 = stylesComputed.getPropertyValue('--color-primary2') || '#ddd'

const stylesByClient = (data: ClientModel['theme'] | undefined) => {
  const themeObject = themeParse({
    primaryColor: PRIMARY,
    primaryColor2: PRIMARY2,
    ...data,
  })
  return css`
    ${themeStringParse(themeObject)};
  `
}
const stylesObjByClient = (theme: ClientModel['theme'] | undefined) =>
  themeParse({
    primaryColor: PRIMARY,
    primaryColor2: PRIMARY2,
    ...theme,
  })

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  stylesByClient,
  stylesObjByClient,
}
